(function () {
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-mt-swatch]');
    if (!swatch) return;

    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    var image = card.querySelector('[data-mt-card-image]');
    if (!image) return;

    var newSrc = swatch.getAttribute('data-variant-image');
    if (!newSrc) return;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = newSrc;

    var alt = swatch.getAttribute('data-variant-alt');
    if (alt) {
      image.alt = alt;
    }

    var group = swatch.closest('.mt-swatches');
    if (group) {
      var buttons = group.querySelectorAll('[data-mt-swatch]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('is-active');
        buttons[i].setAttribute('aria-current', 'false');
      }
    }

    swatch.classList.add('is-active');
    swatch.setAttribute('aria-current', 'true');
  });
})();
